var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.489,88.278l-14.2-8.2A9.638,9.638,0,0,0,11.159,83.6L2,99.463a9.638,9.638,0,0,0,3.518,13.128l70.518,40.714Z",
    fill: "#83D989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.938,65.269,67.829,51.225A9.637,9.637,0,0,0,54.7,47.707L38.833,56.869A9.639,9.639,0,0,0,35.316,70l40.622,70.359Z",
    fill: "#83D989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,64.116V47.856a9.638,9.638,0,0,0-9.61-9.61H91.577a9.638,9.638,0,0,0-9.61,9.61v81.287Z",
    fill: "#83D989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.283,84.141l8.2-14.2a9.637,9.637,0,0,0-3.518-13.127L147.1,47.649a9.638,9.638,0,0,0-13.128,3.518L93.256,121.685Z",
    fill: "#83D989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.652,80.968,93.636,128.319a18.772,18.772,0,0,0,18.772,32.514l82.015-47.352a9.637,9.637,0,0,0,3.518-13.127l-9.162-15.869A9.638,9.638,0,0,0,175.652,80.968Zm-71.13,70.823a7.028,7.028,0,1,1,2.572-9.6A7.028,7.028,0,0,1,104.522,151.791Z",
    fill: "#83D989"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDesign);
export default __webpack_public_path__ + "static/media/web-design.8275a3c0b2e2399b0630a83bc8b274a5.svg";
export { ForwardRef as ReactComponent };